import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ChecklistService } from 'src/app/Service/checklist/checklist.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { ChecklistModel } from 'src/app/ViewModel/ChecklistModel';
import { GridComponent } from '@progress/kendo-angular-grid';
import { FormGroup, FormControl } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { CopyBulkChecklist } from '../dialogs/Copy-Bulk-Checklist/Copy_Bulk_Checklist';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { I } from '@angular/cdk/keycodes';


const createFormGroup = (dataItem: { clDescription: any; clId: any; clShortDescription: any; disciplineDescription: any; disciplineId: any; groupId: any; isActive: any; revisionNo: any; createdBy?: number; buid: any; icid: any; projectId: any; icDescription: any; buDescription: any; projectDescription: any; isClone: any; groupDescription?: any; }) => new FormGroup({
	'clDescription': new FormControl(dataItem.clDescription),
	'clId': new FormControl(dataItem.clId),
	'clShortDescription': new FormControl(dataItem.clShortDescription),
	'icid': new FormControl(dataItem.icid),
	'icDescription': new FormControl(dataItem.icDescription),
	'buid': new FormControl(dataItem.buid),
	'buDescription': new FormControl(dataItem.buDescription),
	'groupId': new FormControl(dataItem.groupId),
	'groupDescription': new FormControl(dataItem.groupDescription),
	'projectId': new FormControl(dataItem.projectId),
	'projectDescription': new FormControl(dataItem.projectDescription),
	'disciplineId': new FormControl(dataItem.disciplineId),
	'disciplineDescription': new FormControl(dataItem.disciplineDescription),
	'isActive': new FormControl(dataItem.isActive),
	'revisionNo': new FormControl(dataItem.revisionNo),
	'isClone': new FormControl(dataItem.isClone),
});

@Component({
	selector: 'app-checklist',
	templateUrl: './checklist.component.html',
	styleUrls: ['./checklist.component.css']
})

export class ChecklistComponent implements OnInit {
	@ViewChild(GridComponent)
	private grid!: GridComponent;

	icList: RoleFeatureModel[]  = [];
	buList: RoleFeatureModel[] = [];
	projectList: ProjectViewModel[] = [];
	businessGroupList: BusinessGroupModel[] = [];
	disciplineList: RoleFeatureModel[]  = [];

	rowIcList: RoleFeatureModel[]  = [];
	rowBuList: RoleFeatureModel[]  = [];
	rowProjectList: ProjectViewModel[] = [];
	rowBusinessGroupList: BusinessGroupModel[] = [];
	rowDisciplineList: RoleFeatureModel[] = [];

	checkList: ChecklistModel[]  = [];

	icid: number | null = null;
	buid: number | null = null;
	projectId: number | null = null;
	businessGroupId: number | null = null;
	disciplineId: number | null = null;

	enablechkLstFilter = false;
	enablechkLstFullscreen = false;
	checklistName: string | null = '';
	showChecklistItem = false;
	isNew = false;
	editedRowIndex: number | any;
	isNewRow = false;
	disableActiveSwitch = true;

	icIsDisabled: boolean = false;
	projectIsDisabled: boolean = false;

	icRowIsDisabled: boolean = false;
	projectRowIsDisabled: boolean = false;

	// clear EIPAutocomplete selected values
	clearIcSelected = 'N';
	clearBuSelected = 'N';
	clearProjectSelected = 'N';
	clearBusinessGroupSelected = 'N';
	clearDisciplineSelected = 'N';

	public formGroup: FormGroup | any;

	constructor(
		public commonService: CommonService,
		public checklistService: ChecklistService,
		public notificationService: NotificationService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public projectInfoService: ProjectInfoService,
		private _dialog: MatDialog,
	) { }

	ngOnInit() {
		this.getIcList();
		this.getBuList();
		this.getProject();
		this.getBusinessGroup(null);
		this.getDiscipline(null);
		//this.getCheckList();
	}

	async getIcList() {
		this.icList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "IC").toPromise();
	}

	async getBuList() {
		if (!this.icid) {
			this.buList = [];
			return;
		}

		this.buList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "BU").toPromise();
	}

	async getProject() {
		this.projectInfoService.getProjectList(this.commonService.getLoggedInUserId()).subscribe((data: ProjectViewModel[]) => {
			this.projectList = data;
			if (this.projectList) {
				this.projectList.forEach(x => { x.projectDescription = x.projectCode + ' - ' + x.projectDescription });
			}
		});
	}

	async getBusinessGroup(projectId: number | null) {
		if (!projectId) {
			this.businessGroupList = [];
			return;
		}

		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data:any) => {
			this.businessGroupList = data.filter((each:any) => each.is_Active);
		});
	}

	async getDiscipline(businessGroupId: number | null) {
		if (!businessGroupId) {
			this.disciplineList = [];
			return;
		}

		this.disciplineList = await this.mapRoleFeatureService.getDedAgainstDe("Discipline", businessGroupId, null, null, 0).toPromise();
	}

	async getRowIcList() {
		this.rowIcList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "IC").toPromise();
	}

	async getRowBuList(icid: number | null) {
		if (!icid) {
			this.rowBuList = [];
			return;
		}

		this.rowBuList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "BU").toPromise();
	}

	async getRowProject() {
		this.projectInfoService.getProjectList(this.commonService.getLoggedInUserId()).subscribe((data: ProjectViewModel[]) => {
			this.rowProjectList = data;
		});
	}

	async getRowBusinessGroup(projectId: number | null) {
		if (!projectId) {
			this.rowBusinessGroupList = [];
			return;
		}

		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data:any) => {
			this.rowBusinessGroupList = data.filter((each:any) => each.is_Active);
		});
	}

	async getRowDiscipline(businessGroupId: number | null) {
		if (!businessGroupId) {
			this.rowDisciplineList = [];
			return;
		}

		this.rowDisciplineList = await this.mapRoleFeatureService.getDedAgainstDe("Discipline", businessGroupId, null, null, 0).toPromise();
	}

	changeIc(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.icIsDisabled = false;
			this.projectIsDisabled = true;
		}
		else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
		}

		this.buid = this.projectId = this.businessGroupId = this.disciplineId = null;
		this.icid = event.value != '-2' ? Number(event.value) : null;

		this.getBuList();
		this.getCheckList();
	}

	changeBu(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.projectId = this.businessGroupId = null;
		}

		this.buid = event.value != '-2' ? Number(event.value) : null;

		this.getCheckList();
	}

	changeProject(event: EIPAutoCompleteEventModel<ProjectViewModel>) {
		if (event.value != '-2') {
			this.icIsDisabled = true;
			this.projectIsDisabled = false;
		}
		else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
		}

		this.icid = this.buid = this.businessGroupId = this.disciplineId = null;
		this.projectId = event.value != '-2' ? Number(event.value) : null;

		this.getBusinessGroup(this.projectId);
		this.disciplineList = [];
		this.getCheckList();
	}

	changeBusinessGroup(event: EIPAutoCompleteEventModel<BusinessGroupModel>) {
		if (event.value != '-2') {
			this.icid = this.buid = null;
			this.businessGroupId = Number(event.value);
			this.getDiscipline(this.businessGroupId);
			this.getCheckList();
		} else {
			this.businessGroupId = null;
			this.disciplineId = null;
			this.disciplineList = [];
			this.getDiscipline(null);
			this.getCheckList();
		}
	}

	changeDiscipline(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		this.disciplineId = event.value != '-2' ? Number(event.value) : null;

		this.getCheckList();
	}

	async getCheckList() {
		if (!this.icid && !this.buid && !this.projectId && !this.businessGroupId && !this.disciplineId) {
			this.checkList = [];
			return
		}

		this.checkList = await this.checklistService.getChecklist(this.businessGroupId, this.disciplineId, this.buid, this.icid, this.projectId).toPromise();
	}

	toggleFilter() {
		this.enablechkLstFilter = !this.enablechkLstFilter;
	}

	toggleChklstFullscreen() {
		this.enablechkLstFullscreen = !this.enablechkLstFullscreen
	}

	setForChecklist(event?: any) {
		this.showChecklistItem = false;
		this.checklistName = null;
		//this.clearSelectedFilter();
		this.getCheckList();
	}

	editRowData({ sender, rowIndex, dataItem }: any) {
		this.checkAnyChecklistItemsIsActive(dataItem);

		//closing previous row, if anything opened
		if (this.editedRowIndex >= 0) {
			sender.closeRow(this.editedRowIndex);
		}

		this.editedRowIndex = rowIndex;
		this.formGroup = createFormGroup(dataItem);
		this.isNewRow = false;
		this.rowDisciplineList = [];

		this.getRowIcList();
		this.getRowBuList(null);
		this.getRowProject();
		this.getRowBusinessGroup(null);
		this.getRowDiscipline(null);

		sender.editRow(rowIndex);
	}
	async CopyRowData({ sender, rowIndex, dataItem }: any) {

		//closing previous row, if anything opened
		if (this.editedRowIndex >= 0) {
			sender.closeRow(this.editedRowIndex);
		}

		this.editedRowIndex = rowIndex;
		dataItem.isClone = true;
		this.formGroup = createFormGroup(dataItem);

		this.isNewRow = true;
		this.rowDisciplineList = [];

		this.getRowIcList();
		this.getRowBuList(null);
		this.getRowProject();
		this.getRowBusinessGroup(null);
		this.getRowDiscipline(null);
		sender.editRow(rowIndex);
	}

	async checkAnyChecklistItemsIsActive(dataItem: ChecklistModel) {
		let checklistItems:any = await this.checklistService.getChecklistItem(dataItem.clId).toPromise();
		let isAnyOneIsTrue = false;
		for (let i = 0; i < checklistItems.length; i++) {
			if (checklistItems[i].isActive) {
				isAnyOneIsTrue = true;
				break;
			}
		}
		this.disableActiveSwitch = isAnyOneIsTrue;
	}

	UpdateRowData({ sender, rowIndex, dataItem }: any) {
		let newChecklist: ChecklistModel = this.formGroup.value;

		if (!newChecklist.clDescription) {
			this.notificationService.showToast('Enter checklist name', 'Warning');
			return;
		}

		if (!newChecklist.icid && !newChecklist.buid && !newChecklist.projectId && !newChecklist.groupId && !newChecklist.disciplineId) {
			this.notificationService.showToast('Please select either IC or BU or Project or Business Group or Discipline', 'Warning');
			return;
		}

		this.saveChecklist();
		this.isNewRow = false;
		sender.closeRow(rowIndex);
	}

	cancelRowData({ sender, rowIndex, dataItem }: any) {
		this.isNewRow = false;
		sender.closeRow(rowIndex);
	}

	addHandler() {
		this.isNewRow = true;
		this.closeEditor();
		this.formGroup = createFormGroup({
			clDescription: '',
			clId: null,
			clShortDescription: '',
			disciplineDescription: '',
			disciplineId: null,
			groupId: null,
			isActive: true,
			revisionNo: null,
			createdBy: this.commonService.getLoggedInUserId(),
			buid: null,
			icid: null,
			projectId: null,
			icDescription: '',
			buDescription: '',
			projectDescription: '',
			isClone: false
		});
		this.isNew = true;

		this.getRowIcList();
		this.getRowBuList(null);
		this.getRowProject();
		this.getRowBusinessGroup(null);
		this.getRowDiscipline(null);

		this.grid.addRow(this.formGroup);
	}

	public cellClickHandler({ isEdited, dataItem, rowIndex }: any): void {
		if (isEdited) {
			return;
		}
		this.formGroup = createFormGroup(dataItem);
		this.editedRowIndex = rowIndex;
		this.grid.editRow(rowIndex, this.formGroup);
	}

	viewChecklistItem(dataItem: ChecklistModel) {
		this.checklistName = dataItem.clDescription;
		this.checklistService.checklistId.next(dataItem.clId);
		this.showChecklistItem = true;
	}

	changeActiveStatus(event: MatCheckboxChange) {
		this.formGroup.get('isActive').setValue(event.checked);
	}

	public cancelHandler(): void {
		this.closeEditor();
	}

	private closeEditor(): void {
		this.grid.closeRow(this.editedRowIndex);

		this.isNew = false;
		this.editedRowIndex = undefined;
		this.formGroup = undefined;
	}

	setRowIc(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.icRowIsDisabled = false;
			this.projectRowIsDisabled = true;
			this.formGroup.get('icid').setValue(event.value);
			this.formGroup.get('icDescription').setValue(event.text);
			this.formGroup.get('buid').setValue(null);
			this.formGroup.get('buDescription').setValue('');
			this.getRowBuList(Number(event.value));
		} else {
			this.icRowIsDisabled = false;
			this.projectRowIsDisabled = false;
			this.formGroup.get('icid').setValue(null);
			this.formGroup.get('icDescription').setValue('');
			this.formGroup.get('buid').setValue(null);
			this.formGroup.get('buDescription').setValue('');
			this.getRowBuList(null);
		}
	}

	setRowBu(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.formGroup.get('buid').setValue(event.value);
			this.formGroup.get('buDescription').setValue(event.text);
		} else {
			this.formGroup.get('buid').setValue(null);
			this.formGroup.get('buDescription').setValue('');
		}
	}

	setRowProject(event: EIPAutoCompleteEventModel<ProjectViewModel>) {
		if (event.value != '-2') {
			this.icRowIsDisabled = true;
			this.projectRowIsDisabled = false;
			this.formGroup.get('projectId').setValue(event.value);
			this.formGroup.get('projectDescription').setValue(event.text);
			this.formGroup.get('groupId').setValue(null);
			this.formGroup.get('groupDescription').setValue('');
			this.formGroup.get('disciplineId').setValue(null);
			this.formGroup.get('disciplineDescription').setValue('');
			this.getRowBusinessGroup(Number(event.value));
			this.getRowDiscipline(null);
		} else {
			this.icRowIsDisabled = false;
			this.projectRowIsDisabled = false;
			this.formGroup.get('projectId').setValue(null);
			this.formGroup.get('projectDescription').setValue('');
			this.formGroup.get('groupId').setValue(null);
			this.formGroup.get('groupDescription').setValue('');
			this.formGroup.get('disciplineId').setValue(null);
			this.formGroup.get('disciplineDescription').setValue('');
			this.getRowDiscipline(null);
			this.getRowBusinessGroup(null);
		}
	}

	async setRowBusiessGrp(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.formGroup.get('groupId').setValue(event.value);
			this.formGroup.get('groupDescription').setValue(event.text);
			this.formGroup.get('disciplineId').setValue(null);
			this.formGroup.get('disciplineDescription').setValue('');
			this.getRowDiscipline(Number(event.value));
		} else {
			this.formGroup.get('groupId').setValue(null);
			this.formGroup.get('groupDescription').setValue('');
			this.formGroup.get('disciplineId').setValue(null);
			this.formGroup.get('disciplineDescription').setValue('');
			this.getRowDiscipline(null);
		}
	}

	setRowDiscipline(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.formGroup.get('disciplineId').setValue(event.value);
			this.formGroup.get('disciplineDescription').setValue(event.text);
		} else {
			this.formGroup.get('disciplineId').setValue(null);
			this.formGroup.get('disciplineDescription').setValue('');
		}
	}

	saveChecklist() {
		if (this.formGroup) {
			let newChecklist: ChecklistModel = this.formGroup.value;


			newChecklist.createdBy = this.commonService.getLoggedInUserId();
			// revision number as 1, by default for new checklist
			if (this.isNewRow) {
				newChecklist.revisionNo = 1;
			}

			this.checklistService.postChecklist(newChecklist).subscribe((data:any) => {
				this.notificationService.handleResponse(data);
				this.getCheckList();
			});
		}
	}

	BulkCopyCheckist() {
		const dialogRef = this._dialog.open(CopyBulkChecklist, {
			panelClass: 'mat-dialog-primary',
			width: '900px',
			data: { IprojectList: this.projectList }
		});
		dialogRef.afterClosed().subscribe((res: any) => {
			if (res) {
				let resproject: any = res.project;
				if (res.response && res.response.successCode == 200) {

					this.notificationService.showToast(res.response.successMessage, "Success");
				}
				else if (res.response.successCode == 205) {
					this.notificationService.showToast(res.response.successMessage, "Warning");
				}
			}
		}, (err:any) => { });
	}



	clearSelectedFilter() {
		this.clearIcSelected = this.clearBuSelected = this.clearProjectSelected = this.clearBusinessGroupSelected = this.clearDisciplineSelected = 'Y';
		this.icid = this.buid = this.projectId = this.businessGroupId = this.disciplineId = null;
		this.icIsDisabled = this.projectIsDisabled = false;
	}
}
